export default __webpack_public_path__ + "static/media/bruno-madruga.c6fdbc25.jpg";